import React from "react";
import {observer} from "mobx-react-lite";
import intl from "react-intl-universal";
import {useRootStore, useUserState} from "@stores/AppStateContext";

import {MarkAsReadIcon} from "../../../../components/icons/MarkAsReadIcon";
import {Button} from "../../../../components/Button";
import {confirmAcknowledgment} from "../../../../../actions/item/confirmAcknowledgment";

import "./AcknowledgmentRow.css"
import {useCrudServices} from "../../../../../platform/hooks/useServiceCombinations";

export const AcknowledgmentRow = observer(() => {
    const rootStore = useRootStore();
    const userState = useUserState();
    const currentUser = userState!.currentUserDb;
    const crudServices = useCrudServices();
    const activeWorkspace = rootStore.view.workspace!;
    const selectedNode = activeWorkspace.selected!;
    return (
        <div className={'acknowledgmentRow_wrapper'}>{selectedNode.acknowledgementRequired
            ? <div className={'acknowledgmentRow'}>
                {!selectedNode.acknowledgement[currentUser!.id]
                    ? <Button
                        className="acknowledgmentRow__markReadButton"
                        Icon={MarkAsReadIcon}
                        text={intl.get('acknowledgment.common').d("Acknowledgment")}
                        type={"success"}
                        style={"solid"}
                        onClick={() => confirmAcknowledgment(crudServices, userState!, selectedNode)}
                    />
                    : <div className="acknowledgmentRow__markedRead">
                        <MarkAsReadIcon className="acknowledgmentRow__markedRead__icon" size={20}/>
                        {intl.get('acknowledgment__isRead').d("You have acknowledged this page.")}
                    </div>}
            </div>
            : null
        }
        </div>
    )
})
